import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui';

interface DiscardConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Wird beim Klick auf "Verwerfen" aufgerufen — dann erst navigieren. */
  onConfirm: () => void;
}

/**
 * Spec 0216 §6.6 EC-7: Confirm-Dialog vor dem Verlassen einer Routing-View
 * mit ungespeicherten Aenderungen.
 *
 * Pattern: gleich aufgebaut wie `delete-confirmation.tsx`/
 * `terminate-confirmation.tsx`. Bewusst kein generisches Refactor — siehe
 * Plan §0.3.
 */
export function DiscardConfirmation({ open, onOpenChange, onConfirm }: DiscardConfirmationProps) {
  const { t } = useTranslation('routing');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>{t('discard.title')}</DialogTitle>
          <DialogDescription>{t('discard.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('discard.cancel')}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {t('discard.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
